import { Fragment } from "react";

import useAccountCreationSelfWarning from "./UseAccountCreationSelfWarning";

import Headings from "@usas/ui-web/components/headings/Headings";
import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";

import style from '../../../../LandingPages.module.css';

const AccountCreationSelfWarning = () => {
  const { onBackClicked, onContinueClicked } = useAccountCreationSelfWarning();

  return (
    <Fragment>
      <div className="row usas-extra-bottom-margin">
        <div className="col-xs-12 col-md-2" />
        <div className={['col-xs-12', 'col-md-8'].join(' ')}>
          <div className={["row", style.CenterPageContent].join(' ')}>  
            <Headings.H3>Important Notice</Headings.H3>
          </div> 
          
          
          <div style={{padding: '1em', borderRadius: '4px'}}  className={["usas-extra-top-margin usas-extra-bottom-margin", 'very-light-gray'].join(' ')}>
            <p>
              <strong>Create an account to purchase or manage a membership for yourself or others, or to complete Education courses for yourself.</strong>
            </p>
            
            <p>Important Notes:</p>
            
            <ul className="row usas-extra-bottom-margin" style={{listStylePosition: 'outside', paddingLeft: '1.9em', paddingRight:'2.2em'}}>
              <li>You are creating a Login Account for yourself.  Please answer all questions with your information.</li>
              <li>Children are not required to create a Login account to sign up for a membership.</li>
              <li>Anyone completing an Education course (e.g., SafeSport, APT, Coaching Courses) must use their own Login Account.</li>
              <li>If you have a child swimmer, we may text you to obtain your consent to creation of your child’s Login account.
                For more information, see our <a href="https://www.usaswimming.org/landing-pages/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy. </a>
              </li>
            </ul>
          </div>

          <div className={["row", style.CenterPageContent].join(' ')}>
            <div className="col-xs-12 usas-extra-top-margin">
              <PrimaryButton onClick={onContinueClicked}>
                I Understand, Continue
              </PrimaryButton>
            </div>
            <div className="col-xs-12 usas-extra-top-margin">
              <SecondaryButton onClick={onBackClicked}>
                Back
              </SecondaryButton>
            </div>
          </div>
        </div>
        <div className="col-xs-12 col-md-2" />
      </div>
    </Fragment>
  );
};

export default AccountCreationSelfWarning;